export default __webpack_public_path__ + "static/media/Guarantee.4801c212.svg";